export default {"src":"/_next/static/media/music_menu.911698a0.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};